import React, { useState, useEffect, useContext } from "react";
import styles from "./Main.module.scss";
import { getVacancies } from "../../service/service";
import { Vacancy } from "../../types/vacancy";
import { Title } from "../../content/title";
import useDebounce from "../../utils/use-debounce";
import { Vacancies } from "../../content/vacancies";
import noVacanciesImage from "../../static/noVacancies.png";
import cn from "classnames";
import { useNavigate, createSearchParams } from 'react-router-dom';
import { LangContext } from "../../store/LangContext";
import loaderIcon from "../../static/loader.svg";
import ArrowRight from "../../static/arrow_right.svg";
import gs from "../../Layout.module.scss";

function Main() {
    const navigate = useNavigate();
    const lang = useContext(LangContext)
    const debounceLang = useDebounce(lang, 100);
    const formatMoney = (amount: string) => {
        if (amount.split(".")[1]?.length < 2) {
            return amount.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + "0";
        }
        return amount.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    };
    const [vacanciesJson, setVacanciesJson] = useState([]);
    const [startList, setStartList] = useState(false)
    useEffect(() => {
        if (lang)
            getVacancies(debounceLang).then((response) => {
                setVacanciesJson(response);
                setStartList(true);
            });
    }, [debounceLang]);
    const schedulesEnum = [
        {
            value: 1,
            label: "2/2",
        },
        {
            value: 2,
            label: "5/2",
        },
        {
            value: 3,
            label: Vacancies.partTime[lang],
        },
        {
            value: 4,
            label: Vacancies.flexible[lang],
        },
        {
            value: 5,
            label: Vacancies.shiftwork[lang],
        },
        {
            value: 6,
            label: Vacancies.remotely[lang],
        },
        {
            value: 7,
            label: Vacancies.shiftMethod[lang],
        },
    ];
    return (
        <div className={styles.app}>
            {!startList ?
                <div className={styles.loaderBox}>
                    <img width={40} src={loaderIcon} className={gs.loader} />
                </div>
                :
                vacanciesJson.length > 0 ? (
                    <div className={styles.vacancies}>
                        <div className={styles.vacancies_container}>
                            {vacanciesJson.map((v: Vacancy, i: number) => {                                
                                return (
                                    <a href={`/vacancy_preview?lang=${lang}&vacancyId=${v.id}`} key={i} className={styles.vacancy_box}>
                                        <div className={styles.vacancy_box_item_header}>
                                            <strong className={styles.vacancy_box_item__black}>{v.vacancyName}</strong>
                                            <img src={ArrowRight} alt="arrow" />
                                        </div>
                                        <div className={cn(styles.vacancy_box_item)}>
                                            <span className={styles.vacancy_box_item__grey}>{Vacancies?.[v.affiliate][lang]}</span>
                                        </div>
                                        <div>
                                            <div className={styles.vacancy_box_item}>
                                                <span className={styles.vacancy_box_item__grey}>{Vacancies.salary[lang]}:</span>
                                                <span className={styles.vacancy_box_item__black}>
                                                    {v?.salaryType === 0
                                                        ? Vacancies.from[lang] + " " + formatMoney(v?.salary?.toString() ?? "")
                                                        : v?.salaryType === 1
                                                            ? Vacancies.to[lang] + " " + formatMoney(v?.salary?.toString() ?? "")
                                                            : v?.salaryType === 2
                                                                ? formatMoney(v?.salary?.toString() ?? "")
                                                                : null}{" "}
                                                    {v.currencySign}
                                                </span>
                                            </div>
                                            <div className={cn(styles.vacancy_box_item)}>
                                                <span className={styles.vacancy_box_item__grey}>{Vacancies.experience[lang]}:</span>
                                                <span className={styles.vacancy_box_item__black}>{v.experience}</span>
                                            </div>
                                            <div className={cn(styles.vacancy_box_item)}>
                                                <span className={styles.vacancy_box_item__grey}>{Vacancies.schedule[lang]}:</span>
                                                <span className={styles.vacancy_box_item__black}>{schedulesEnum.find((e) => e.value === +v.schedule)?.label}</span>
                                            </div>
                                        </div>
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                ) : (
                    <div className={styles.noVacanciesMessageBlock}>
                        <img src={noVacanciesImage} alt="noVacanciesImage" />
                        <div className={styles.noVacanciesMessage}>
                            <b>{Title.noVacanciesMessageHeader[lang]}</b>
                            <p>{Title.noVacanciesMessage[lang]}</p>
                        </div>
                    </div>
                )
            }
        </div>
    );
}

export default Main;
